/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ActionToRoleResource', 'model/PermissionsResponse', 'model/ResponseObject'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ActionToRoleResource'), require('../model/PermissionsResponse'), require('../model/ResponseObject'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.PermissionsApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.ActionToRoleResource, root.GisServerApis.PermissionsResponse, root.GisServerApis.ResponseObject);
  }
}(this, function(ApiClient, ActionToRoleResource, PermissionsResponse, ResponseObject) {
  'use strict';

  /**
   * Permissions service.
   * @module api/PermissionsApi
   * @version 1.0.0
   */

  /**
   * Constructs a new PermissionsApi. 
   * @alias module:api/PermissionsApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the addPermissionsToRolesV1 operation.
     * @callback module:api/PermissionsApi~addPermissionsToRolesV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add the permissions to roles.
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/ActionToRoleResource>} opts.actionsToRole A collection of menu permissions. Each item contains an action and a role ID.
     * @param {module:api/PermissionsApi~addPermissionsToRolesV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.addPermissionsToRolesV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['actionsToRole'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/permission', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getPermissionsByRoleIdV1 operation.
     * @callback module:api/PermissionsApi~getPermissionsByRoleIdV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/PermissionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the permissions for a specified role.
     * @param {String} roleId The role ID to query.
     * @param {module:api/PermissionsApi~getPermissionsByRoleIdV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PermissionsResponse}
     */
    this.getPermissionsByRoleIdV1 = function(roleId, callback) {
      var postBody = null;

      // verify the required parameter 'roleId' is set
      if (roleId === undefined || roleId === null) {
        throw new Error("Missing the required parameter 'roleId' when calling getPermissionsByRoleIdV1");
      }


      var pathParams = {
        'roleId': roleId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = PermissionsResponse;

      return this.apiClient.callApi(
        '/api/v1/permission/{roleId}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getPermissionsV1 operation.
     * @callback module:api/PermissionsApi~getPermissionsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/PermissionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all the permissions.
     * @param {module:api/PermissionsApi~getPermissionsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PermissionsResponse}
     */
    this.getPermissionsV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = PermissionsResponse;

      return this.apiClient.callApi(
        '/api/v1/permission', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the removePermissionsFromRoleV1 operation.
     * @callback module:api/PermissionsApi~removePermissionsFromRoleV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove the assigned permissions from role.
     * @param {String} roleId The role ID to remove the permissions from.
     * @param {module:api/PermissionsApi~removePermissionsFromRoleV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.removePermissionsFromRoleV1 = function(roleId, callback) {
      var postBody = null;

      // verify the required parameter 'roleId' is set
      if (roleId === undefined || roleId === null) {
        throw new Error("Missing the required parameter 'roleId' when calling removePermissionsFromRoleV1");
      }


      var pathParams = {
        'roleId': roleId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/permission/{roleId}', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

